// @ts-nocheck
import { useEffect } from 'react';
import config from './config';

export default function GoogleAnalytics() {
  useEffect(() => {
    // Google tag manager
    if (config.googleAnalyticsMeasurementId) {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag('js', new Date());

      gtag('config', config.googleAnalyticsMeasurementId);
    }
  }, []);

  return (
    <script
      async
      src={`https://www.googletagmanager.com/gtag/js?id=${config.googleAnalyticsMeasurementId}`}
    />
  );
}
